import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutComponent } from './layout.component';
import { Session } from '@app/app.session';
import {environment} from '@env/environment';

@Component({
    selector: 'app-topbar',
    template: `
        <div class="topbar clearfix">
            <div class="topbar-left">
                <div class="logo" routerLink="/" style="cursor: pointer"></div>
            </div>

            <div style="float: right; top: 20px; position: relative; font-size: 25px; right: 25px;">
              <span class="logged-user">{{session.user?.lastName}} {{session.user?.firstName}} ({{ session.mainRole }})</span>
              <a href="#" (click)="logout()"><i class="material-icons">power_settings_new</i></a>
            </div>

            <div class="topbar-right">
            </div>
        </div>
    `
})
export class LayoutTopbarComponent
{

    constructor(public app:LayoutComponent,
                public i18n:TranslateService,
                public session:Session) {}

    get isMultiLang() : boolean {
        return (this.i18n.langs && this.i18n.langs.length > 1);
    }

    onLangChange(selectedLang:string) {
        this.i18n.use(selectedLang);
    }
  logout() {
    this.cleanStorages();
    window.location.href = `${environment.context}api/auth/logout`;
  }
  cleanStorages(){
      localStorage.clear();
      sessionStorage.clear();
    }
}
